import { baseApi, TAG } from '../../app/api/baseApi'
const entitiesUrl = (connectorId, instanceId) => `/Connection/${connectorId}/instance/${instanceId}/entities`
const toEntity = (entity) => ({
    id: entity.id,
    displayName: entity.displayName || entity.name || '',
    isInboundActive: Boolean(entity.isInboundActive),
    isOutboundActive: Boolean(entity.isOutboundActive),
    isInboundEditable: entity.isInboundEditable === true,
    isOutboundEditable: entity.isOutboundEditable === true,
    packetSize: typeof entity.packetSize === 'number' ? entity.packetSize : null,
    lastSyncTime: [entity.sourceSyncTime, entity.targetSyncTime].filter(Boolean).sort().pop() || null
})
const listTag = (connectorId, instanceId) => ({ type: TAG.MANAGED_ENTITY, id: `${connectorId}|${instanceId}` })
export const entitiesApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getManagedEntities: builder.query({
            query: ({ connectorId, instanceId }) => entitiesUrl(connectorId, instanceId),
            transformResponse: (data) => (Array.isArray(data) ? data.map(toEntity) : []),
            providesTags: (result, error, { connectorId, instanceId }) => [listTag(connectorId, instanceId)]
        }),
        updateEntityStatus: builder.mutation({
            query: ({ connectorId, instanceId, entityId, isInboundActive, isOutboundActive }) => ({
                url: `${entitiesUrl(connectorId, instanceId)}/${entityId}`,
                method: 'POST',
                body: { isInboundActive, isOutboundActive }
            }),
            transformResponse: (data) => data || {},
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                const patch = dispatch(
                    entitiesApi.util.updateQueryData(
                        'getManagedEntities',
                        { connectorId: args.connectorId, instanceId: args.instanceId },
                        (entities) => {
                            const entity = entities.find((item) => item.id === args.entityId)
                            if (entity) {
                                entity.isInboundActive = args.isInboundActive
                                entity.isOutboundActive = args.isOutboundActive
                            }
                        }
                    )
                )
                try {
                    const { data } = await queryFulfilled
                    if (data.result === false) {
                        patch.undo()
                    }
                } catch (error) {
                    patch.undo()
                }
            }
        })
    })
})

export const { useGetManagedEntitiesQuery, useUpdateEntityStatusMutation } = entitiesApi
